import { render, staticRenderFns } from "./EcommerceDashboardTemplate.vue?vue&type=template&id=639d8a85&"
import script from "./EcommerceDashboardTemplate.vue?vue&type=script&lang=js&"
export * from "./EcommerceDashboardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports